<script>
    // @ts-nocheck
    import {
        BackDrop,
        Typography,
        TertiaryButton,
        Spinner,
        Modal,
        Button,
    } from '$lib/components/UI'
    import user from '$lib/stores/user'
    import { API_URL, ENV } from '$lib/conf'
    import { areEquals } from '$lib/utils'
    import SucursalCard from '$lib/custom/components/SucursalCard.svelte'
    import SucursalWidget from '$lib/custom/components/SucursalWidget.svelte'
    import AddCircle from '$lib/components/Icons/AddCircle.svelte'

    let loading = false
    let showModalAdd = false
    let showModalSucursal = false
    let currentSucursal = {}
    let formData = {}
    let auxSucursalData = {}
    let editable = false

    let sucursals = getSucursales()
    function getSucursales() {
        return user.token && user.currentAccount
            ? user.fetch(`${API_URL}/branchoffices/${user.currentAccount}`).then(async (r) => await r.json())
            : sucursals
    }


    function addSucursal() {
        formData = {}
        showModalAdd = true
    }

    function viewSucursal() {
        showModalSucursal = true
    }
    console.log({ENV})

    async function updateSucursal() {
        if (user.isLogined() && !loading) {
            loading = true
            await user.fetch(`${API_URL}/branchoffices/${user.currentAccount}`, {
                method: 'PUT',
                body: JSON.stringify(currentSucursal),
            }).then(async (r) => {
                showModalSucursal = false
                editable = false
                loading = false
                return await r.json()
            })
            sucursals = getSucursales().then((r) => {
                auxSucursalData = {}
                currentSucursal = {}
                return r
            })
        }
    }

    async function toggleSucursalStatus() {
        if (user.isLogined()) {
            loading = true
            await user.fetch(`${API_URL}/branchoffices/${user.currentAccount}`, {
                method: 'PUT',
                body: JSON.stringify({
                    uuid: currentSucursal.uuid,
                    activa: !currentSucursal.activa,
                }),
            }).then(async (r) => {
                showModalSucursal = false
                loading = false
                return await r.json()
            })
            sucursals = getSucursales().then((r) => {
                currentSucursal = {}
                auxSucursalData = {}
                return r
            })
        }
    }

    async function sendSucursal() {
        if (user.isLogined()) {
            loading = true
            await user.fetch(`${API_URL}/branchoffices/${user.currentAccount}`, {
                method: 'POST',
                body: JSON.stringify(formData),
            }).then(async (r) => {
                showModalAdd = false
                loading = false
                return await r.json()
            })
            sucursals = getSucursales().then((r) => {
                formData = {}
                return r
            })
        }
    }

    async function deleteSucursal() {
        if (user.isLogined()) {
            loading = true
            await user.fetch(`${API_URL}/branchoffices/${user.currentAccount}`, {
                method: 'DELETE',
                body: JSON.stringify({ uuid: currentSucursal.uuid }),
            })
                .then(async (r) => {
                    showConfirmacion = false
                    loading = false
                    return await r.json()
                })
                .catch((err) => {
                    loading = false
                })
            sucursals = getSucursales()
        }
    }

    let validForm = false
    let showConfirmacion = false

    $: changeFormData = !areEquals(currentSucursal, auxSucursalData)
    $: okModification = loading ? false : changeFormData && validForm
    $: console.log({ okModification, currentSucursal })
</script>

<div
    style="width: 100%; padding: 25px 68px 68px 68px;min-height: calc(100% - 70px); position:relative"
>
    {#await sucursals}
        <div class="dg">
            <Spinner />
        </div>
    {:then data}
        <div class="title">
            <span>
                <Typography type="h2" style="margin: 0; padding: 0"
                    >Mis Sucursales</Typography
                >
                <Typography
                    type="body"
                    style="margin: 0; padding: 0"
                    color="grey-800">Gestioná tus Sucursales</Typography
                >
            </span>
            <span>
                {#if ENV.MODE == 'development'}
                    <Button
                        size="small"
                        style="padding: 4px 8px; gap: 4px; width: 215px"
                        on:click={addSucursal}
                    >
                        <AddCircle color="#FFF" />
                        <Typography type="body" color="white">Agregar Sucursal</Typography>
                    </Button>
                {/if}
            </span>
        </div>
        {#if data?.length}
            <div class="container">
                {#each data as sucursal, i (i)}
                    <SucursalCard
                        on:click={() => {
                            currentSucursal = structuredClone(sucursal)
                            auxSucursalData = structuredClone(sucursal)
                            viewSucursal()
                        }}
                        data={sucursal}
                        {i}
                    />
                {/each}
            </div>
        {:else}
            <div class="dg">
                <Typography
                    type="h3"
                    style="margin: 0; padding: 0"
                    color="grey-400">No hay sucursales</Typography
                >
                <TertiaryButton
                    icon={AddCircle}
                    label="Agregar sucursal"
                    on:click={addSucursal}
                />
            </div>
        {/if}
    {:catch err}
        <p>{err}</p>
    {/await}
    <BackDrop visible={showModalAdd} style="position: fixed">
        <SucursalWidget
            disabled={loading}
            bind:valid={validForm}
            bind:data={formData}
            on:close={() => {
                showModalAdd = false
            }}
        >
            <svelte:fragment slot="buttonSet">
                <Button
                    disabled={!validForm || loading}
                    label="Agregar"
                    on:click={sendSucursal}
                />
            </svelte:fragment>
        </SucursalWidget>
    </BackDrop>
    <BackDrop visible={showModalSucursal} style="position: fixed">
        <SucursalWidget
            bind:data={currentSucursal}
            bind:valid={validForm}
            title="Editar sucursal"
            disabled={!editable}
            on:close={() => {
                editable = false
                showModalSucursal = false
            }}
        >
            <svelte:fragment slot="buttonSet">
                {#key currentSucursal}
                    {#if editable}
                        <Button
                            disabled={loading}
                            type="other"
                            on:click={() => {
                                currentSucursal =
                                    structuredClone(auxSucursalData)
                                editable = false
                            }}>Cancelar</Button
                        >
                        <Button
                            disabled={!okModification}
                            on:click={updateSucursal}>Guardar</Button
                        >
                    {:else}
                        <Button
                            disabled={loading}
                            on:click={toggleSucursalStatus}
                            type="secondary"
                            >{currentSucursal.activa
                                ? 'Desactivar'
                                : 'Reactivar'}</Button
                        >
                        <Button
                            disabled={loading}
                            type="other"
                            on:click={() => {
                                showModalSucursal = false
                                showConfirmacion = true
                            }}>Eliminar</Button
                        >
                        <Button
                            disabled={loading}
                            on:click={() => (editable = true)}>Editar</Button
                        >
                    {/if}
                {/key}
            </svelte:fragment>
        </SucursalWidget>
    </BackDrop>

    <BackDrop visible={showConfirmacion} style="position: fixed">
        <Modal
            title={`¿Está seguro de que desea eliminar la sucursal "${currentSucursal.nombre}"?`}
            on:close={() => {
                showConfirmacion = false
            }}
            on:clickout={() => {
                showConfirmacion = false
            }}
        >
            <svelte:fragment slot="buttonSet">
                <Button
                    disabled={loading}
                    type="other"
                    label="Cancelar"
                    on:click={() => {
                        showConfirmacion = false
                    }}
                />
                <Button
                    disabled={loading}
                    style="self-align: flex-start"
                    label="Eliminar"
                    on:click={deleteSucursal}
                />
            </svelte:fragment>
        </Modal>
    </BackDrop>
</div>

<style>
    .dg {
        width: 100%;
        position: relative;
        height: 250px;
        padding: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        gap: 20px;
    }
    .title {
        width: 100%;
        margin: 25px 0 30px 0;
        display: flex;
        justify-content: space-between;
        flex-direction: row;
    }
    .title span {
        display: flex;
        gap: 10px;
        flex-direction: column;
        justify-content: center;
    }
    .container {
        min-height: fit-content;
        /* min-height: calc(100vh - 70px); */
        width: auto-fit;
        grid-template-columns: repeat(auto-fit, 375px);
        grid-template-rows: repeat(auto-fill, minmax(115px, 1fr));
        grid-gap: 30px;
        align-items: center;
        margin: 0 0 75px 0;
        /* justify-content: center; */
        display: grid;
        position: relative;
    }
</style>
